// extracted by mini-css-extract-plugin
export var searchHeader = "_90-0";
export var searchHeaderDark = "_90-1";